var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyHole(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3.72 6.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "variables"
  }, /*#__PURE__*/React.createElement("g", {
    id: "portal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "keyicons_-_closed",
    "data-name": "keyicons - closed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.19,6.66l1-3.42A1.63,1.63,0,1,1,3.52,1.77a1.64,1.64,0,0,1-1,1.5l1,3.4H.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72,6.8H0L1,3.31A1.77,1.77,0,1,1,3.66,1.77a1.75,1.75,0,0,1-1,1.57ZM.38,6.52h3l-1-3.34.12-.05a1.47,1.47,0,0,0,.9-1.36,1.49,1.49,0,1,0-3,0,1.5,1.5,0,0,0,.86,1.35l.11,0Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyHole);
export default __webpack_public_path__ + "static/media/key-hole.bc076476.svg";
export { ForwardRef as ReactComponent };